import { getBaseMetaTitle } from '@/environments'

import symposiumAuth from '@/middleware/symposium.js'

const Main = () => import('@/components/Creativity/Main')
const Program = () => import('@/components/Creativity/Program')
const TalkSymposium = () => import('@/components/Creativity/TalkSymposium')
const SchoolOfCreativity = () =>
  import('@/components/Creativity/SchoolOfCreativity')
const SchoolOfCreativityDetail = () =>
  import('@/components/Creativity/SchoolOfCreativityDetail')
const SymposiumStage = () =>
  import('@/components/Creativity/SymposiumStage')
const SymposiumStageDetail = () =>
  import('@/components/Creativity/SymposiumStageDetail')
const Detail = () => import('@/components/Creativity/Parts/Detail')

const route = {
  path: '/symposium',
  name: 'symposium',
  meta: {
    title: `Symposium - ${getBaseMetaTitle}`
  },
  component: Main,
  children: [
    {
      path: 'program',
      name: 'creativity_program',
      meta: {
        title: `Symposium - ${getBaseMetaTitle}`
      },
      components: {
        mainCreativity: Program
      }
    },
    {
      path: 'talk_symposium',
      name: 'creativity_talk_symposium',
      meta: {
        title: `Symposium - ${getBaseMetaTitle}`
      },
      props: true,
      components: {
        mainCreativity: TalkSymposium
      },
      children: [
        {
          path: ':id',
          name: 'creativity_talk_symposium_detail',
          meta: {
            title: `Symposium - ${getBaseMetaTitle}`
          },
          props: true,
          components: {
            talkSymposiumDetail: Detail
          }
        }
      ]
    },
    // {
    //   path: 'speakers',
    //   name: 'creativity_school_of_creativity',
    //   meta: {
    //     title: `Symposium - ${getBaseMetaTitle}`
    //   },
    //   components: {
    //     mainCreativity: SchoolOfCreativity
    //   },
    //   children: [
    //     {
    //       path: ':mainId-:detailId',
    //       name: 'creativity_school_of_creativity_detail',
    //       meta: {
    //         title: `Symposium - ${getBaseMetaTitle}`
    //       },
    //       components: {
    //         schoolsDetail: SchoolOfCreativityDetail
    //       }
    //     }
    //   ]
    // },
    {
      path: 'sessions',
      name: 'SymposiumStage',
      meta: {
        title: `Symposium All Stage - ${getBaseMetaTitle}`
      },
      components: {
        mainCreativity: SymposiumStage
      },
      children: [
        {
          path: ':mainId',
          name: 'SymposiumStageDetail',
          meta: {
            title: `Symposium Stage - ${getBaseMetaTitle}`
          },
          components: {
            schoolsDetail: SymposiumStageDetail
          },
          children: [
            {
              path: ':sessionId',
              name: 'SymposiumSessionDetail',
              meta: {
                title: `Symposium Session - ${getBaseMetaTitle}`
              },
              components: {
                schoolsDetail: SymposiumStageDetail
              }
            }
          ]
        }
      ]
    },
    {
      path: 'video',
      name: 'symposium_video',
      meta: {
        title: `Symposium - ${getBaseMetaTitle}`,
        middleware: symposiumAuth
      },
      components: {
        mainContent: () => import('@/components/Symposium/VideoList')
      }
    },
    {
      path: 'video/login',
      name: 'symposium_video_login',
      meta: {
        title: `Symposium - ${getBaseMetaTitle}`
      },
      components: {
        mainContent: () => import('@/components/Symposium/Login')
      }
    },
    {
      path: 'video/:id',
      name: 'symposium_video_detail',
      meta: {
        title: `Symposium - ${getBaseMetaTitle}`,
        middleware: symposiumAuth
      },
      components: {
        mainContent: () => import('@/components/Symposium/VideoDetail')
      }
    }
  ]
}

export default route
